<template>
  <div :class="{english:lang=='EN'}">
    <div class="hidden-xs">
      <!--      <div class="core-technology" ref="coreTechnology" @click="understandMore('localIntelligent')" >-->
      <section class="l-block" id="lineList">
        <div class="l-inner">
          <h4 class="l-inner-title">{{ $t('home.mainLine') }}</h4>
          <div class="primary-line-box primary-line-box01">
            <div class="primary-item-left">
              <div class="item-left-box">
                <div class="line-title">{{ $t('home.chinaRailwayExpress') }}</div>
              </div>
            </div>
            <div class="primary-item-right">
              <ul>
                <!--                <li onclick="window.location.href='journalism/russiaRoute'">-->
                <li>
                  <div class="item-line-img"><img src="../../../assets/img/coretec/zbew_icon.png"></div>
                  <div class="item-line-name">{{ $t('home.chinaRailwayExpress1') }}</div>
                  <div class="item-line-text">{{ $t('home.chinaRailwayExpress2') }}</div>
                </li>
                <!--                <li onclick="window.location.href='journalism/russiaRoute'">-->
                <li>
                  <div class="item-line-img"><img src="../../../assets/img/coretec/zxn_icon.png"></div>
                  <div class="item-line-name">{{ $t('home.chinaRailwayExpress3') }}</div>
                  <div class="item-line-text">{{ $t('home.chinaRailwayExpress4') }}</div>
                </li>
                <!--                <li onclick="window.location.href='journalism/russiaRoute'">-->
                <li>
                  <div class="item-line-img"><img src="../../../assets/img/coretec/oz_icon.png"></div>
                  <div class="item-line-name">{{ $t('home.chinaRailwayExpress5') }}</div>
                  <div class="item-line-text">{{ $t('home.chinaRailwayExpress6') }}</div>
                </li>
              </ul>
            </div>
          </div>
          <div class="primary-line-box primary-line-box02">
            <div class="primary-item-left">
              <div class="item-left-box">
                <div class="line-title">{{ $t('home.seaRail') }}</div>
              </div>
            </div>
            <div class="primary-item-right">
              <ul>
                <!--                <li onclick="window.location.href='journalism/russiaRoute'">-->
                <li>
                  <div class="item-line-img"><img src="../../../assets/img/coretec/nb_icon.png"></div>
                  <div class="item-line-name">{{ $t('home.seaRail1') }}</div>
                  <div class="item-line-text">{{ $t('home.seaRail2') }}</div>
                </li>
                <!--                <li onclick="window.location.href='journalism/russiaRoute'">-->
                <li>
                  <div class="item-line-img"><img src="../../../assets/img/coretec/qd_icon.png"></div>
                  <div class="item-line-name">{{ $t('home.seaRail3') }}</div>
                  <div class="item-line-text">{{ $t('home.seaRail4') }}</div>
                </li>
              </ul>
            </div>
          </div>
          <!--          <div class="primary-line-box primary-line-box03">-->
          <!--            <div class="primary-item-left">-->
          <!--              <div class="item-left-box">-->
          <!--                <div class="line-title">+西欧</div>-->
          <!--              </div>-->
          <!--            </div>-->
          <!--            <div class="primary-item-right2">-->
          <!--              <ul id="scroll-box07">-->
          <!--                <li onclick="window.location.href='journalism/jiaXOIntroduce'">-->
          <!--                  <div class="item-line-img"><img src="../../../assets/img/coretec/xiang_icon.png"></div>-->
          <!--                  <div class="item-line-name">襄西欧</div>-->
          <!--                </li>-->
          <!--                <li onclick="window.location.href='journalism/jiaXOIntroduce'">-->
          <!--                  <div class="item-line-img"><img src="../../../assets/img/coretec/xu_icon.png"></div>-->
          <!--                  <div class="item-line-name">徐西欧</div>-->
          <!--                </li>-->
          <!--                <li onclick="window.location.href='journalism/jiaXOIntroduce'">-->
          <!--                  <div class="item-line-img"><img src="../../../assets/img/coretec/bang_icon.png"></div>-->
          <!--                  <div class="item-line-name">朗西欧</div>-->
          <!--                </li>-->
          <!--                <li onclick="window.location.href='journalism/jiaXOIntroduce'">-->
          <!--                  <div class="item-line-img"><img src="../../../assets/img/coretec/xiang_icon.png"></div>-->
          <!--                  <div class="item-line-name">冀西欧</div>-->
          <!--                </li>-->
          <!--                <li onclick="window.location.href='journalism/jiaXOIntroduce'">-->
          <!--                  <div class="item-line-img"><img src="../../../assets/img/coretec/xu_icon.png"></div>-->
          <!--                  <div class="item-line-name">厦西欧</div>-->
          <!--                </li>-->
          <!--                <li onclick="window.location.href='journalism/jiaXOIntroduce'">-->
          <!--                  <div class="item-line-img"><img src="../../../assets/img/coretec/bang_icon.png"></div>-->
          <!--                  <div class="item-line-name">唐西欧</div>-->
          <!--                </li>-->
          <!--              </ul>-->
          <!--            </div>-->
          <!--          </div>-->
        </div>
      </section>
      <section class="l-hotLine" id="hotLine">
        <div class="l-inner">
          <h4 class="l-inner-title">{{ $t('home.hotLine') }}</h4>
          <ul class="l-hotLine-items u-justify-start">
            <li class="l-hotLine-item u-justify-start">
              <div class="l-hotLine-box">
                <div class="l-hotLine-desc">
                  <div class="front front01">
                    <div class="inner">
                      <p class="l-hotLine-item-title">{{ $t('home.hotLine1') }}<img class="l-hotLine-ic"
                                                                                    src="../../../assets/img/coretec/ic.png">{{
                          $t('home.hotLine11')
                        }}<img
                          class="l-hotLine-ic" src="../../../assets/img/coretec/ic.png">{{ $t('home.hotLine12') }}</p>
                      <div class="l-hotLine-item-desc">
                        <p>{{ $t('home.schedule') }}</p>
                        <p><span>1-7</span>{{ $t('home.columnWeek') }}</p>
                      </div>
                      <div class="l-hotLine-item-desc">
                        <p>{{ $t('home.aging') }}</p>
                        <p><span>16~18</span>{{ $t('home.day') }}</p>
                      </div>
                    </div>
                  </div>
                  <div class="back">
                    <div class="inner">
                      <p class="l-hotLine-item-title2">{{ $t('home.hotLine13') }}</p>
                      <div class="l-hotLine-item-desc2">
                        <p>{{ $t('home.hotLine14') }}</p>
                        <p>
                          {{ $t('home.hotLine15') }}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </li>
            <li class="l-hotLine-item u-justify-center">
              <div class="l-hotLine-box">
                <div class="l-hotLine-desc">
                  <div class="front front02">
                    <div class="inner">
                      <p class="l-hotLine-item-title">{{ $t('home.hotLine2') }}<img class="l-hotLine-ic"
                                                                                    src="../../../assets/img/coretec/ic.png">{{
                          $t('home.hotLine21')
                        }}<img
                          class="l-hotLine-ic" src="../../../assets/img/coretec/ic.png">{{ $t('home.hotLine22') }}</p>
                      <div class="l-hotLine-item-desc">
                        <p>{{ $t('home.schedule') }}</p>
                        <p><span>1-7</span>{{ $t('home.columnWeek') }}</p>
                      </div>
                      <div class="l-hotLine-item-desc">
                        <p>{{ $t('home.aging') }}</p>
                        <p><span>16~22</span>{{ $t('home.day') }}</p>
                      </div>
                    </div>
                  </div>
                  <div class="back">
                    <div class="inner">
                      <p class="l-hotLine-item-title2">{{ $t('home.hotLine23') }}</p>
                      <div class="l-hotLine-item-desc2">
                        <p>
                          {{ $t('home.hotLine24') }}</p>
                        <p>
                          {{ $t('home.hotLine25') }}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </li>
            <li class="l-hotLine-item u-justify-end">
              <div class="l-hotLine-box">
                <div class="l-hotLine-desc">
                  <div class="front front03">
                    <div class="inner">
                      <p class="l-hotLine-item-title">{{ $t('home.hotLine3') }}<img class="l-hotLine-ic"
                                                                                    src="../../../assets/img/coretec/ic.png">{{
                          $t('home.hotLine31')
                        }}<img
                          class="l-hotLine-ic" src="../../../assets/img/coretec/ic.png">{{ $t('home.hotLine32') }}</p>
                      <div class="l-hotLine-item-desc">
                        <p>{{ $t('home.schedule') }}</p>
                        <p><span>1-7</span>{{ $t('home.columnWeek') }}</p>
                      </div>
                      <div class="l-hotLine-item-desc">
                        <p>{{ $t('home.aging') }}</p>
                        <p><span>9~12</span>{{ $t('home.day') }}</p>
                      </div>
                    </div>
                  </div>
                  <div class="back">
                    <div class="inner">
                      <p class="l-hotLine-item-title2">{{ $t('home.hotLine33') }}</p>
                      <div class="l-hotLine-item-desc2">
                        <p>
                          {{ $t('home.hotLine34') }}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </li>
          </ul>
          <ul class="l-hotLine-items u-justify-start">
            <li class="l-hotLine-item u-justify-start">
              <div class="l-hotLine-box">
                <div class="l-hotLine-desc">
                  <div class="front front01">
                    <div class="inner">
                      <p class="l-hotLine-item-title">{{ $t('home.hotLine4') }}<img class="l-hotLine-ic"
                                                                                    src="../../../assets/img/coretec/ic.png">{{
                          $t('home.hotLine41')
                        }}<img
                          class="l-hotLine-ic" src="../../../assets/img/coretec/ic.png">{{ $t('home.hotLine42') }}</p>
                      <div class="l-hotLine-item-desc">
                        <p>{{ $t('home.schedule') }}</p>
                        <p><span>1-7</span>{{ $t('home.columnWeek') }}</p>
                      </div>
                      <div class="l-hotLine-item-desc">
                        <p>{{ $t('home.aging') }}</p>
                        <p><span>14~22</span>{{ $t('home.day') }}</p>
                      </div>
                    </div>
                  </div>
                  <div class="back">
                    <div class="inner">
                      <p class="l-hotLine-item-title2">{{ $t('home.hotLine43') }}</p>
                      <div class="l-hotLine-item-desc2">
                        <p>{{ $t('home.hotLine44') }}</p>
                        <p>
                          {{ $t('home.hotLine45') }}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </li>
            <li class="l-hotLine-item u-justify-center">
              <div class="l-hotLine-box">
                <div class="l-hotLine-desc">
                  <div class="front front02">
                    <div class="inner">
                      <p class="l-hotLine-item-title">{{ $t('home.hotLine5') }}<img class="l-hotLine-ic"
                                                                                    src="../../../assets/img/coretec/ic.png">{{
                          $t('home.hotLine51')
                        }}<img
                          class="l-hotLine-ic" src="../../../assets/img/coretec/ic.png">{{ $t('home.hotLine52') }}</p>
                      <div class="l-hotLine-item-desc">
                        <p>{{ $t('home.schedule') }}</p>
                        <p><span>1-7</span>{{ $t('home.columnWeek') }}</p>
                      </div>
                      <div class="l-hotLine-item-desc">
                        <p>{{ $t('home.aging') }}</p>
                        <p><span>15~22</span>{{ $t('home.day') }}</p>
                      </div>
                    </div>
                  </div>
                  <div class="back">
                    <div class="inner">
                      <p class="l-hotLine-item-title2">{{ $t('home.hotLine53') }}</p>
                      <div class="l-hotLine-item-desc2">
                        <p>
                          {{ $t('home.hotLine54') }}</p>
                        <p>
                          {{ $t('home.hotLine55') }}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </li>
            <li class="l-hotLine-item u-justify-end">
              <div class="l-hotLine-box">
                <div class="l-hotLine-desc">
                  <div class="front front03">
                    <div class="inner">
                      <p class="l-hotLine-item-title">{{ $t('home.hotLine6') }}<img class="l-hotLine-ic"
                                                                                    src="../../../assets/img/coretec/ic.png">{{
                          $t('home.hotLine61')
                        }}<img
                          class="l-hotLine-ic" src="../../../assets/img/coretec/ic.png">{{ $t('home.hotLine62') }}</p>
                      <div class="l-hotLine-item-desc">
                        <p>{{ $t('home.schedule') }}</p>
                        <p><span>1-7</span>{{ $t('home.columnWeek') }}</p>
                      </div>
                      <div class="l-hotLine-item-desc">
                        <p>{{ $t('home.aging') }}</p>
                        <p><span>11~22</span>{{ $t('home.day') }}</p>
                      </div>
                    </div>
                  </div>
                  <div class="back">
                    <div class="inner">
                      <p class="l-hotLine-item-title2">{{ $t('home.hotLine63') }}</p>
                      <div class="l-hotLine-item-desc2">
                        <p>{{ $t('home.hotLine64') }}</p>
                        <p>
                          {{ $t('home.hotLine65') }}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </section>
      <div class="core-technology" ref="coreTechnology">
        <div style="width: 100%;display: flex;max-width:80rem; margin:0 auto;">
          <img src="../../../assets/img/mainpage/yewufanwei.png" style="max-width:100%;"/>
          <div class="banner-operate animated wow fadeInUp">
            <div style="display: flex;justify-content: center;flex-direction: column;z-index: 1000">
              <div class="title">{{ $t('home.coreTechnology') }}</div>
              <div class="introduction">{{ $t('home.message1') }}</div>
              <!--            <div class="core-technology-ul">-->
              <!--              <div class="core-technology-item" @click.stop="understandMore('localIntelligent')">-->
              <!--                <img class="item-img" src="../../../assets/img/mainpage/Tech07.png" />-->
              <!--                <span class="item-title">{{$t('home.localIntelligent')}}</span>-->
              <!--              </div>-->
              <!--              <div class="core-technology-item" @click.stop="understandMore('face')">-->
              <!--                <img class="item-img" src="../../../assets/img/mainpage/Tech04.png" />-->
              <!--                <span class="item-title">{{$t('home.face')}}</span>-->
              <!--              </div>-->
              <!--              <div class="core-technology-item" @click.stop="understandMore('action')">-->
              <!--                <img class="item-img" src="../../../assets/img/mainpage/Tech03.png" />-->
              <!--                <span class="item-title">{{$t('home.action')}}</span>-->
              <!--              </div>-->
              <!--              <div class="core-technology-item" @click.stop="understandMore('goal')">-->
              <!--                <img class="item-img" src="../../../assets/img/mainpage/Tech02.png" />-->
              <!--                <span class="item-title">{{$t('home.target')}}</span>-->
              <!--              </div>-->
              <!--            </div>-->
              <!--            <div class="core-technology-ul">-->
              <!--              <div class="core-technology-item" @click.stop="understandMore('flaw')">-->
              <!--                <img class="item-img" src="../../../assets/img/mainpage/Tech01.png" />-->
              <!--                <span class="item-title">{{$t('home.defect')}}</span>-->
              <!--              </div>-->

              <!--              <div class="core-technology-item" @click.stop="understandMore('VideoAnalysis')">-->
              <!--                <img class="item-img" src="../../../assets/img/mainpage/Tech05.png" />-->
              <!--                <span class="item-title">{{$t('home.hxVideo')}}</span>-->
              <!--              </div>-->
              <!--              <div class="core-technology-item" @click.stop="understandMore('DataAnalysis')">-->
              <!--                <img class="item-img" src="../../../assets/img/mainpage/Tech06.png" />-->
              <!--                <span class="item-title">{{$t('home.hxData')}}</span>-->
              <!--              </div>-->
              <!--              <div class="core-technology-item" style="opacity:0">-->
              <!--                <img class="item-img" src="../../../assets/img/mainpage/Tech06.png" />-->
              <!--                <span class="item-title">{{$t('home.hxData')}}</span>-->
              <!--              </div>-->
              <!--            </div>-->
              <div class="operate" @click.stop="understandMore('localIntelligent')">
                <!--                <div class="operate-button understand-more">-->
                <!--                  {{$t('common.learnMore')}}-->
                <!--                  <div class="unserstand-more-logo"></div>-->
                <!--                </div>-->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="visible-xs">
      <section class="l-block" id="lineList2">
        <div class="l-inner">
          <h4 class="l-inner-title">{{ $t('home.mainLine') }}</h4>
          <div class="primary-line-box primary-line-box01">
            <div class="primary-item-left">
              <div class="item-left-box">
                <div class="line-title">{{ $t('home.chinaRailwayExpress') }}</div>
              </div>
            </div>
            <div class="primary-item-right">
              <ul>
                <!--                <li onclick="window.location.href='journalism/russiaRoute'">-->
                <li>
                  <div class="item-line-img"><img src="../../../assets/img/coretec/zbew_icon.png"></div>
                  <div class="item-line-name">{{ $t('home.chinaRailwayExpress1') }}</div>
                  <div class="item-line-text">{{ $t('home.chinaRailwayExpress2') }}</div>
                </li>
                <!--                <li onclick="window.location.href='journalism/russiaRoute'">-->
                <li>
                  <div class="item-line-img"><img src="../../../assets/img/coretec/zxn_icon.png"></div>
                  <div class="item-line-name">{{ $t('home.chinaRailwayExpress3') }}</div>
                  <div class="item-line-text">{{ $t('home.chinaRailwayExpress4') }}</div>
                </li>
                <!--                <li onclick="window.location.href='journalism/russiaRoute'">-->
                <li>
                  <div class="item-line-img"><img src="../../../assets/img/coretec/oz_icon.png"></div>
                  <div class="item-line-name">{{ $t('home.chinaRailwayExpress5') }}</div>
                  <div class="item-line-text">{{ $t('home.chinaRailwayExpress6') }}</div>
                </li>
              </ul>
            </div>
          </div>
          <div class="primary-line-box primary-line-box02">
            <div class="primary-item-left">
              <div class="item-left-box">
                <div class="line-title">{{ $t('home.seaRail') }}</div>
              </div>
            </div>
            <div class="primary-item-right">
              <ul>
                <!--                <li onclick="window.location.href='journalism/russiaRoute'">-->
                <li>
                  <div class="item-line-img"><img src="../../../assets/img/coretec/nb_icon.png"></div>
                  <div class="item-line-name">{{ $t('home.seaRail1') }}</div>
                  <div class="item-line-text">{{ $t('home.seaRail2') }}</div>
                </li>
                <!--                <li onclick="window.location.href='journalism/russiaRoute'">-->
                <li>
                  <div class="item-line-img"><img src="../../../assets/img/coretec/qd_icon.png"></div>
                  <div class="item-line-name">{{ $t('home.seaRail3') }}</div>
                  <div class="item-line-text">{{ $t('home.seaRail4') }}</div>
                </li>
              </ul>
            </div>
          </div>
          <!--          <div class="primary-line-box primary-line-box03">-->
          <!--            <div class="primary-item-left">-->
          <!--              <div class="item-left-box">-->
          <!--                <div class="line-title">+西欧</div>-->
          <!--              </div>-->
          <!--            </div>-->
          <!--            <div class="primary-item-right2">-->
          <!--              <ul id="scroll-box08">-->
          <!--                <li onclick="window.location.href='journalism/jiaXOIntroduce'">-->
          <!--                  <div class="item-line-img"><img src="../../../assets/img/coretec/xiang_icon.png"></div>-->
          <!--                  <div class="item-line-name">襄西欧</div>-->
          <!--                </li>-->
          <!--                <li onclick="window.location.href='journalism/jiaXOIntroduce'">-->
          <!--                  <div class="item-line-img"><img src="../../../assets/img/coretec/xu_icon.png"></div>-->
          <!--                  <div class="item-line-name">徐西欧</div>-->
          <!--                </li>-->
          <!--                <li onclick="window.location.href='journalism/jiaXOIntroduce'">-->
          <!--                  <div class="item-line-img"><img src="../../../assets/img/coretec/bang_icon.png"></div>-->
          <!--                  <div class="item-line-name">朗西欧</div>-->
          <!--                </li>-->
          <!--                <li onclick="window.location.href='journalism/jiaXOIntroduce'">-->
          <!--                  <div class="item-line-img"><img src="../../../assets/img/coretec/xiang_icon.png"></div>-->
          <!--                  <div class="item-line-name">冀西欧</div>-->
          <!--                </li>-->
          <!--                <li onclick="window.location.href='journalism/jiaXOIntroduce'">-->
          <!--                  <div class="item-line-img"><img src="../../../assets/img/coretec/xu_icon.png"></div>-->
          <!--                  <div class="item-line-name">厦西欧</div>-->
          <!--                </li>-->
          <!--                <li onclick="window.location.href='journalism/jiaXOIntroduce'">-->
          <!--                  <div class="item-line-img"><img src="../../../assets/img/coretec/bang_icon.png"></div>-->
          <!--                  <div class="item-line-name">唐西欧</div>-->
          <!--                </li>-->
          <!--              </ul>-->
          <!--            </div>-->
          <!--          </div>-->
        </div>
      </section>
      <section class="l-hotLine" id="hotLine2">
        <div class="l-inner">
          <h4 class="l-inner-title">{{ $t('home.hotLine') }}</h4>
          <ul class="l-hotLine-items u-justify-start">
            <li class="l-hotLine-item u-justify-start">
              <div class="l-hotLine-box">
                <div class="l-hotLine-desc">
                  <div class="front front01">
                    <div class="inner">
                      <p class="l-hotLine-item-title">{{ $t('home.hotLine1') }}<img class="l-hotLine-ic"
                                                                                    src="../../../assets/img/coretec/ic.png">{{
                          $t('home.hotLine11')
                        }}<img
                          class="l-hotLine-ic" src="../../../assets/img/coretec/ic.png">{{ $t('home.hotLine12') }}</p>
                      <div class="l-hotLine-item-desc">
                        <p>{{ $t('home.schedule') }}</p>
                        <p><span>1-7</span>{{ $t('home.columnWeek') }}</p>
                      </div>
                      <div class="l-hotLine-item-desc">
                        <p>{{ $t('home.aging') }}</p>
                        <p><span>16~18</span>{{ $t('home.day') }}</p>
                      </div>
                    </div>
                  </div>
                  <div class="back">
                    <div class="inner">
                      <p class="l-hotLine-item-title2">{{ $t('home.hotLine13') }}</p>
                      <div class="l-hotLine-item-desc2">
                        <p>{{ $t('home.hotLine14') }}</p>
                        <p>
                          {{ $t('home.hotLine15') }}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </li>
            <li class="l-hotLine-item u-justify-center">
              <div class="l-hotLine-box">
                <div class="l-hotLine-desc">
                  <div class="front front02">
                    <div class="inner">
                      <p class="l-hotLine-item-title">{{ $t('home.hotLine2') }}<img class="l-hotLine-ic"
                                                                                    src="../../../assets/img/coretec/ic.png">{{
                          $t('home.hotLine21')
                        }}<img
                          class="l-hotLine-ic" src="../../../assets/img/coretec/ic.png">{{ $t('home.hotLine22') }}</p>
                      <div class="l-hotLine-item-desc">
                        <p>{{ $t('home.schedule') }}</p>
                        <p><span>1-7</span>{{ $t('home.columnWeek') }}</p>
                      </div>
                      <div class="l-hotLine-item-desc">
                        <p>{{ $t('home.aging') }}</p>
                        <p><span>16~22</span>{{ $t('home.day') }}</p>
                      </div>
                    </div>
                  </div>
                  <div class="back">
                    <div class="inner">
                      <p class="l-hotLine-item-title2">{{ $t('home.hotLine23') }}</p>
                      <div class="l-hotLine-item-desc2">
                        <p>
                          {{ $t('home.hotLine24') }}</p>
                        <p>
                          {{ $t('home.hotLine25') }}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </li>
            <li class="l-hotLine-item u-justify-end">
              <div class="l-hotLine-box">
                <div class="l-hotLine-desc">
                  <div class="front front03">
                    <div class="inner">
                      <p class="l-hotLine-item-title">{{ $t('home.hotLine3') }}<img class="l-hotLine-ic"
                                                                                    src="../../../assets/img/coretec/ic.png">{{
                          $t('home.hotLine31')
                        }}<img
                          class="l-hotLine-ic" src="../../../assets/img/coretec/ic.png">{{ $t('home.hotLine32') }}</p>
                      <div class="l-hotLine-item-desc">
                        <p>{{ $t('home.schedule') }}</p>
                        <p><span>1-7</span>{{ $t('home.columnWeek') }}</p>
                      </div>
                      <div class="l-hotLine-item-desc">
                        <p>{{ $t('home.aging') }}</p>
                        <p><span>9~12</span>{{ $t('home.day') }}</p>
                      </div>
                    </div>
                  </div>
                  <div class="back">
                    <div class="inner">
                      <p class="l-hotLine-item-title2">{{ $t('home.hotLine33') }}</p>
                      <div class="l-hotLine-item-desc2">
                        <p>
                          {{ $t('home.hotLine34') }}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </li>
          </ul>
          <ul class="l-hotLine-items u-justify-start">
            <li class="l-hotLine-item u-justify-start">
              <div class="l-hotLine-box">
                <div class="l-hotLine-desc">
                  <div class="front front01">
                    <div class="inner">
                      <p class="l-hotLine-item-title">{{ $t('home.hotLine4') }}<img class="l-hotLine-ic"
                                                                                    src="../../../assets/img/coretec/ic.png">{{
                          $t('home.hotLine41')
                        }}<img
                          class="l-hotLine-ic" src="../../../assets/img/coretec/ic.png">{{ $t('home.hotLine42') }}</p>
                      <div class="l-hotLine-item-desc">
                        <p>{{ $t('home.schedule') }}</p>
                        <p><span>1-7</span>{{ $t('home.columnWeek') }}</p>
                      </div>
                      <div class="l-hotLine-item-desc">
                        <p>{{ $t('home.aging') }}</p>
                        <p><span>14~22</span>{{ $t('home.day') }}</p>
                      </div>
                    </div>
                  </div>
                  <div class="back">
                    <div class="inner">
                      <p class="l-hotLine-item-title2">{{ $t('home.hotLine43') }}</p>
                      <div class="l-hotLine-item-desc2">
                        <p>{{ $t('home.hotLine44') }}</p>
                        <p>
                          {{ $t('home.hotLine45') }}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </li>
            <li class="l-hotLine-item u-justify-center">
              <div class="l-hotLine-box">
                <div class="l-hotLine-desc">
                  <div class="front front02">
                    <div class="inner">
                      <p class="l-hotLine-item-title">{{ $t('home.hotLine5') }}<img class="l-hotLine-ic"
                                                                                    src="../../../assets/img/coretec/ic.png">{{
                          $t('home.hotLine51')
                        }}<img
                          class="l-hotLine-ic" src="../../../assets/img/coretec/ic.png">{{ $t('home.hotLine52') }}</p>
                      <div class="l-hotLine-item-desc">
                        <p>{{ $t('home.schedule') }}</p>
                        <p><span>1-7</span>{{ $t('home.columnWeek') }}</p>
                      </div>
                      <div class="l-hotLine-item-desc">
                        <p>{{ $t('home.aging') }}</p>
                        <p><span>15~22</span>{{ $t('home.day') }}</p>
                      </div>
                    </div>
                  </div>
                  <div class="back">
                    <div class="inner">
                      <p class="l-hotLine-item-title2">{{ $t('home.hotLine53') }}</p>
                      <div class="l-hotLine-item-desc2">
                        <p>
                          {{ $t('home.hotLine54') }}</p>
                        <p>
                          {{ $t('home.hotLine55') }}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </li>
            <li class="l-hotLine-item u-justify-end">
              <div class="l-hotLine-box">
                <div class="l-hotLine-desc">
                  <div class="front front03">
                    <div class="inner">
                      <p class="l-hotLine-item-title">{{ $t('home.hotLine6') }}<img class="l-hotLine-ic"
                                                                                    src="../../../assets/img/coretec/ic.png">{{
                          $t('home.hotLine61')
                        }}<img
                          class="l-hotLine-ic" src="../../../assets/img/coretec/ic.png">{{ $t('home.hotLine62') }}</p>
                      <div class="l-hotLine-item-desc">
                        <p>{{ $t('home.schedule') }}</p>
                        <p><span>1-7</span>{{ $t('home.columnWeek') }}</p>
                      </div>
                      <div class="l-hotLine-item-desc">
                        <p>{{ $t('home.aging') }}</p>
                        <p><span>11~22</span>{{ $t('home.day') }}</p>
                      </div>
                    </div>
                  </div>
                  <div class="back">
                    <div class="inner">
                      <p class="l-hotLine-item-title2">{{ $t('home.hotLine63') }}</p>
                      <div class="l-hotLine-item-desc2">
                        <p>{{ $t('home.hotLine64') }}</p>
                        <p>
                          {{ $t('home.hotLine65') }}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </section>
      <div class="core-technology" ref="coreTechnology" @click="understandMore('localIntelligent')">
        <div class="title">{{ $t('home.coreTechnology') }}</div>
        <div class="introduction">{{ $t('home.message1') }}</div>
        <div class="banner-operate animated wow fadeInUp">

          <div style="display: flex;justify-content: center;flex-direction: column;z-index: 1000">

            <!--            <div class="core-technology-ul">-->
            <!--              <div class="core-technology-item" @click.stop="understandMore('localIntelligent')">-->
            <!--                <img class="item-img" src="../../../assets/img/mainpage/Tech07.png" />-->
            <!--                <span class="item-title">{{$t('home.localIntelligent')}}</span>-->
            <!--              </div>-->
            <!--              <div class="core-technology-item" @click.stop="understandMore('face')">-->
            <!--                <img class="item-img" src="../../../assets/img/mainpage/Tech04.png" />-->
            <!--                <span class="item-title">{{$t('home.face')}}</span>-->
            <!--              </div>-->
            <!--              <div class="core-technology-item" @click.stop="understandMore('action')">-->
            <!--                <img class="item-img" src="../../../assets/img/mainpage/Tech03.png" />-->
            <!--                <span class="item-title">{{$t('home.action')}}</span>-->
            <!--              </div>-->
            <!--              <div class="core-technology-item" @click.stop="understandMore('goal')">-->
            <!--                <img class="item-img" src="../../../assets/img/mainpage/Tech02.png" />-->
            <!--                <span class="item-title">{{$t('home.target')}}</span>-->
            <!--              </div>-->
            <!--            </div>-->
            <!--            <div class="core-technology-ul">-->
            <!--              <div class="core-technology-item" @click.stop="understandMore('flaw')">-->
            <!--                <img class="item-img" src="../../../assets/img/mainpage/Tech01.png" />-->
            <!--                <span class="item-title">{{$t('home.defect')}}</span>-->
            <!--              </div>-->
            <!--              <div class="core-technology-item" @click.stop="understandMore('VideoAnalysis')">-->
            <!--                <img class="item-img" src="../../../assets/img/mainpage/Tech05.png" />-->
            <!--                <span class="item-title">{{$t('home.hxVideo')}}</span>-->
            <!--              </div>-->
            <!--              <div class="core-technology-item" @click.stop="understandMore('DataAnalysis')">-->
            <!--                <img class="item-img" src="../../../assets/img/mainpage/Tech06.png" />-->
            <!--                <span class="item-title">{{$t('home.hxData')}}</span>-->
            <!--              </div>-->
            <!--              <div class="core-technology-item" style="opacity: 0;">-->
            <!--                <img class="item-img" src="../../../assets/img/mainpage/Tech02.png" />-->
            <!--                <span class="item-title">{{$t('home.target')}}</span>-->
            <!--              </div>-->
            <!--            </div>-->
            <!--            <div class="operate">-->
            <!--              <div class="operate-button understand-more" @click.stop="understandMore('localIntelligent')">-->
            <!--                {{$t('common.learnMore')}}-->
            <!--                <div class="unserstand-more-logo"></div>-->
            <!--              </div>-->
            <!--            </div>-->
          </div>
        </div>
        <img
          class="img-fluid banner-img"
          src="../../../assets/img/mainpage/yewufanwei.png"
        />
      </div>
    </div>
  </div>
</template>

<script>
import {WOW} from 'wowjs'
import {mapGetters} from 'vuex'
import {ScrollPic} from '../../../../static/js/ScrollPic'

export default {
  name: 'MainCoreTechnology',
  methods: {
    understandMore (index) {
      this.$router.push({path: 'CoreTechnology', query: {position: index}})
      // this.$router.push({path:"CoreTechnology"})
    },
  },
  mounted () {
    const wow = new WOW({
      boxClass: 'wow',
      animateClass: 'animated',
      offset: 0,
      mobile: false,
      live: false
    })
    wow.init()
    // const carouselName = new ScrollPic({
    //   scrollContId: 'scroll-box07',
    //   frameWidth: '100%',
    //   pageWidth: 1,
    //   speed: 10,
    //   space: 10,
    //   autoPlay: true,
    //   autoPlayTime: 0.01
    // })
    // carouselName.initialize()
    // let idName='scroll-box07';
    // var carouselName = new ScrollPic();
    // carouselName.scrollContId = idName; // 内容容器ID,picList1加到容器上，
    // carouselName.frameWidth = "100%"; //显示框的宽度
    // carouselName.pageWidth = 1; //翻页宽度
    // carouselName.speed = 10; //移动速度(单位毫秒，越小越快)
    // carouselName.space = 10; //每次移动像素(单位px，越大越快)
    // carouselName.autoPlay = true; //自动播放
    // carouselName.autoPlayTime = 0.01; //自动播放间隔时间(秒)
    // carouselName.initialize(); //初始化
  },

  computed: {
    ...mapGetters(['lang'])
  }
}

</script>

<style lang="scss" scoped>
.core-technology {
  width: 100%;
  height: auto;
  position: relative;
  background: linear-gradient(to right, #B4E1FF, #FDFEFF);
}

.hidden-xs {
  .l-inner {
    background: #f9f9f9;
    width: 1300px;
    margin: 0 auto;
    font-size: 0;
  }

  .l-inner-title {
    background: #f9f9f9;
    font-size: 3rem;
    color: #333;
    margin-bottom: 45px;
    text-align: center;
    font-family: Arial, Source Han Sans CN;
    font-weight: 400;
    color: rgba(63, 74, 93, 1);
    line-height: 4.38rem;
    letter-spacing: 0.25rem;
    padding-top: 3.5rem;
  }

  /*主营线路*/
  .primary-line-box {
    display: flex;
    padding: 20px;
  }

  /*白色系*/
  .l-block {
    background: url(../../../assets/img/coretec/bg03.png) no-repeat center top;
    background-size: 100% 110%;
  }

  .primary-line-box01 {
    background: url(../../../assets/img/coretec/line04.png) no-repeat center top;
  }

  .primary-line-box02 {
    margin: 40px 0;
    background: url(../../../assets/img/coretec/line05.png) no-repeat center top;
  }

  .primary-line-box03 {
    background: url(../../../assets/img/coretec/line06.png) no-repeat center top;
  }

  .primary-item-left {
    border-right: 1px solid #eaeaea;
  }

  .item-left-box {
    color: #333;
  }

  .item-left-box a {
    border: 1px solid #3B8EF6;
    color: #3B8EF6;
  }

  .primary-item-right ul li {
    color: #333;
  }


  .primary-item-left {
    width: 20%;
    flex-direction: column;
    position: relative;
  }

  .item-left-box {
    position: absolute;
    width: 100%;
    top: 50%;
    transform: translateY(-50%);
    text-align: center;
  }

  .item-left-box .line-title {
    font-size: 24px;
    font-weight: bold;
    margin-bottom: 20px;
  }

  .item-left-box a {
    text-decoration-line: none;
    padding: 3px 15px;
    font-size: 14px;
    border-radius: 3px;
  }

  .primary-item-right {
    flex: 1;
    flex-direction: column;
    padding: 0 20px;
  }

  .primary-item-right ul {
    display: flex;
  }

  .primary-line-box01 li {
    cursor: pointer;
  }

  .primary-line-box02 li {
    cursor: pointer;
  }

  .primary-item-right ul li {
    width: 27.33%;
    flex-direction: column;
    text-align: left;
    margin: 0 3%;
  }

  .primary-item-right .item-line-img, .primary-item-right2 .item-line-img {
    width: 100%;
  }

  .primary-item-right .item-line-img img, .primary-item-right2 .item-line-img img {
    width: 80px;
    height: 80px;
  }

  .primary-item-right .item-line-name, .primary-item-right2 .item-line-name {
    font-size: 18px;
    margin: 20px 0 10px 0;
  }

  .primary-item-right .item-line-text, .primary-item-right2 .item-line-text {
    font-size: 14px;
    line-height: 25px;
  }

  /*主营线路轮播*/
  .primary-item-right2 {
    flex: 1;
    padding: 0 20px;
    overflow: hidden;
  }

  .primary-item-right2 li {
    float: left;
    text-align: center;
    width: 200px;
    margin: 0 20px;
    cursor: pointer;
  }


  .primary-item-left {
    width: 20%;
    flex-direction: column;
    position: relative;
  }

  /* 热门线路 */
  /*弹性盒子元素将向行起始位置对齐（从左到右排布）*/
  .u-justify-start {
    display: -webkit-flex;
    display: -moz-flex;
    display: -ms-flex;
    display: -o-flex;
    display: flex;
    -webkit-justify-content: flex-start;
    -moz-justify-content: flex-start;
    -ms-justify-content: flex-start;
    -o-justify-content: flex-start;
    justify-content: flex-start;
  }

  /*弹性盒子元素将向行结束位置对齐(从右向左排布)*/
  .u-justify-end {
    display: -webkit-flex;
    display: -moz-flex;
    display: -ms-flex;
    display: -o-flex;
    display: flex;
    -webkit-justify-content: flex-end;
    -moz-justify-content: flex-end;
    -ms-justify-content: flex-end;
    -o-justify-content: flex-end;
    justify-content: flex-end;
  }

  .l-hotLine {
    padding: 70px 0;
    background: #fff;
  }

  .l-hotLine-item {
    width: 33.3333%;
  }

  .l-hotLine-box {
    width: 390px;
    height: 340px;
  }

  .l-hotLine-desc {
    -webkit-perspective: 1000px;
    perspective: 1000px;
    width: 100%;
    min-height: 370px;
    position: relative;
    -webkit-transition: -webkit-transform 0.7s cubic-bezier(0.4, 0.2, 0.2, 1);
    transition: -webkit-transform 0.7s cubic-bezier(0.4, 0.2, 0.2, 1);
    -o-transition: transform 0.7s cubic-bezier(0.4, 0.2, 0.2, 1);
    transition: transform 0.7s cubic-bezier(0.4, 0.2, 0.2, 1);
    transform-style: preserve-3d;
    -webkit-transform-style: preserve-3d
  }

  .l-hotLine-box:hover .l-hotLine-desc {
    transform: rotateY(180deg);
    -webkit-transform: rotateY(180deg)
  }

  .front, .back {
    width: 100%;
    min-height: 370px;
    height: auto;
    text-align: center;
    border-radius: 6px;
    position: absolute;
    top: 0;
    left: 0;
    -webkit-backface-visibility: hidden;
    backface-visibility: hidden;
  }

  .front .inner {
    margin-top: 30px;
  }

  .front01 {
    background: url(../../../assets/img/coretec/hot01_icon22.png) no-repeat center top;
    background-position-y: -9px;
  }

  .front02 {
    background: url(../../../assets/img/coretec/hot02_icon22.png) no-repeat center top;
    background-position-y: -7px;
  }

  .front03 {
    background: url(../../../assets/img/coretec/hot03_icon22.png) no-repeat center top;
    background-position-y: -9px;
  }

  .front {
    z-index: 1;
    display: block;
    opacity: 1;
    padding: 40px;
    background-color: #fff;
    height: 100%;
    box-shadow: 0px 0px 18px 0px rgba(0, 0, 0, 0.15);
  }

  .back {
    padding: 30px;
    background: url(../../../assets/img/coretec/hotLine-bg.png);
    box-shadow: 0px 0px 32px 0px rgba(0, 0, 0, 0.3);
    background-repeat: no-repeat;
    line-height: 24px;
    background-size: 110%;
  }

  .l-hotLine-desc .back {
    -webkit-transform: rotateY(180deg);
    transform: rotateY(180deg);
    -webkit-transform-style: preserve-3d;
    transform-style: preserve-3d
  }

  .l-hotLine-desc .front {
    -webkit-transform: rotateY(0deg);
    transform: rotateY(0deg);
    -webkit-transform-style: preserve-3d;
    transform-style: preserve-3d
  }

  .l-hotLine-img {
    width: 164px;
    margin-bottom: 30px;
  }

  .l-hotLine-item-title {
    font-size: 22px;
    line-height: normal;
    //text-align: left;
    margin-bottom: 96px;
    color: #333;
    height: 60px;
    font-weight: bold;
    text-align: center;
  }

  .l-hotLine-ic {
    width: 36px;
    margin: 0 5px;
  }

  .l-hotLine-item-desc {
    font-size: 18px;
    color: #888888;
    display: flex;
    text-align: left;
  }

  .l-hotLine-item-desc p:first-child {
    text-align: right;
    width: 45%;
  }

  .l-hotLine-item-desc p:last-child {
    flex: 1;
    font-weight: bold;
    color: #333;
    margin-left: 15px;
  }

  .l-hotLine-item-desc span {
    color: #057EFF;
  }


  .l-hotLine-item-title2 {
    font-size: 26px;
    color: #333;
    margin-bottom: 25px;
  }

  .l-hotLine-item-desc2 {
    font-size: 14px;
    text-align: left;
    text-indent: 2em;
    color: #888888;
  }

  .l-hotLine-item-desc2 p {
    text-indent: 2em;
  }
}

.hidden-xs .banner-operate {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  // position: absolute;
  // z-index: 1001;
  // height: 100%;
  // left: 50%;
  // top: 0;

  .title {
    width: auto;
    display: inline-block;
    text-align: center;
    font-size: 3rem;
    font-family: Arial, Source Han Sans CN;
    font-weight: 400;
    color: rgba(51, 51, 51, 1);
    line-height: 3rem;
    letter-spacing: 1px;
    @media screen and (min-width: 1400px) and (max-width: 1600px) {
      font-size: 2rem;
    }
  }

  .introduction {
    margin-top: 1.88rem;
    max-width: 36.62rem;
    line-height: 30px;
    text-indent: 2rem;
    width: 100%;
    font-size: 0.88rem;
    font-family: Arial, Source Han Sans CN;
    font-weight: 400;
    color: rgba(102, 102, 102, 1);
    // line-height:1.31rem;
    letter-spacing: 1px;
    @media screen and (min-width: 1200px) and (max-width: 1600px) {
      font-size: 1rem;
    }
  }

  .core-technology-ul {
    display: flex;
    justify-content: space-between;
    max-width: 38.25rem;
    width: 100%;
    margin-top: 1.88rem;

    .core-technology-item {
      display: flex;
      flex-direction: column;
      align-items: center;
      width: 8.25rem;
      cursor: pointer;

      .item-img {
        width: 5.75rem;
        // border:1px dashed rgba(0,0,0,0.3);
        margin-bottom: 0.5rem;
      }

      .item-title {
        font-size: 1rem;
        font-family: Arial, Source Han Sans CN;
        font-weight: 400;
        color: rgba(63, 74, 93, 1);
        line-height: 1.25rem;
      }
    }
  }

  .operate {
    display: flex;
    justify-content: left;
    margin-top: 2.5rem;
    // max-width: 9rem;
    .operate-button {
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      width: 10.75rem;
      height: 3.25rem;
    }

    .understand-more {
      background: url("../../../assets/img/mainpage/button01.png") no-repeat;
      background-size: contain;

      .unserstand-more-logo {
        background: url("../../../assets/img/mainpage/arrow_black.png") no-repeat;
        background-size: contain;
        width: 1.21rem;
        height: 0.525rem;
        margin-left: 0.375rem;
      }
    }

    .understand-more:hover {
      background: url("../../../assets/img/mainpage/button01_active.png") no-repeat;
      background-size: contain;
      color: #ffffff;

      .unserstand-more-logo {
        background: url("../../../assets/img/mainpage/Arrow.png") no-repeat;
        background-size: contain;
        width: 1.21rem;
        height: 0.525rem;
        margin-left: 0.375rem;
      }
    }
  }
}

.visible-xs {
  .l-inner {
    background: #f9f9f9;
    width: 100%;
    margin: 0 auto;
    font-size: 0;
  }

  .l-inner-title {
    background: #f9f9f9;
    font-size: 1.5rem;
    color: #333;
    //margin-bottom: 45px;
    text-align: center;
    font-family: Arial, Source Han Sans CN;
    font-weight: 400;
    color: rgba(63, 74, 93, 1);
    line-height: 4.38rem;
    letter-spacing: 0.35rem;
    padding-top: 1.5rem;
  }

  /*主营线路*/
  .primary-line-box {
    //display: flex;
    padding: 10px;
  }

  /*白色系*/
  .l-block {
    background: url(../../../assets/img/coretec/bg03.png) no-repeat center top;
    background-size: 100% 110%;
  }

  .primary-line-box01 {
    background: url(../../../assets/img/coretec/line04.png) no-repeat center top;
  }

  .primary-line-box02 {
    //margin: 40px 0;
    background: url(../../../assets/img/coretec/line05.png) no-repeat center top;
  }

  .primary-line-box03 {
    background: url(../../../assets/img/coretec/line06.png) no-repeat center top;
  }

  .primary-item-left {
    //border-right: 2px solid #eaeaea;
  }

  .item-left-box {
    color: #333;
  }

  .item-left-box a {
    border: 1px solid #3B8EF6;
    color: #3B8EF6;
  }

  .primary-item-right ul li {
    color: #333;
  }


  .primary-item-left {
    width: 100%;
    flex-direction: column;
    //position: relative;
    //writing-mode: vertical-lr;/*从左向右 从右向左是 writing-mode: vertical-rl;*/
    //writing-mode: tb-lr;/*IE浏览器的从左向右 从右向左是 writing-mode: tb-rl；*/
  }

  .item-left-box {
    //position: absolute;
    //width: 100%;
    //top: 50%;
    //transform: translateY(-50%);
    text-align: center;
  }

  .item-left-box .line-title {
    //white-space: pre-wrap;
    font-size: 20px;
    text-align: center;
    font-weight: bold;
  }

  .item-left-box a {
    text-decoration-line: none;
    padding: 3px 15px;
    font-size: 14px;
    border-radius: 3px;
  }

  .primary-item-right {
    flex: 1;
    //flex-direction: column;
    //padding: 10px;
  }

  .primary-item-right ul {
    display: flex;
    margin: 5px;
    padding: 0px;
  }

  .primary-line-box01 li {
    cursor: pointer;
  }

  .primary-line-box02 li {
    cursor: pointer;
  }

  .primary-item-right ul li {
    width: 30.33%;
    flex-direction: column;
    text-align: left;
    margin: 0 3%;
  }

  .primary-item-right .item-line-img, .primary-item-right2 .item-line-img {
    width: 100%;
  }

  .primary-item-right .item-line-img img, .primary-item-right2 .item-line-img img {
    width: 80px;
    height: 80px;
  }

  .primary-item-right .item-line-name, .primary-item-right2 .item-line-name {
    font-size: 18px;
    margin: 20px 0 10px 0;
  }

  .primary-item-right .item-line-text, .primary-item-right2 .item-line-text {
    font-size: 14px;
    line-height: 25px;
  }

  /*主营线路轮播*/
  .primary-item-right2 {
    flex: 1;
    padding: 0 20px;
    overflow: hidden;
  }

  .primary-item-right2 li {
    float: left;
    text-align: center;
    width: 200px;
    margin: 0 20px;
    cursor: pointer;
  }


  .primary-item-left {
    width: 28%;
    flex-direction: column;
    position: relative;
  }

  ///* 热门线路 */
  ///*弹性盒子元素将向行起始位置对齐（从左到右排布）*/
  //.u-justify-start {
  //  display: -webkit-flex;
  //  display: -moz-flex;
  //  display: -ms-flex;
  //  display: -o-flex;
  //  display: flex;
  //  -webkit-justify-content: flex-start;
  //  -moz-justify-content: flex-start;
  //  -ms-justify-content: flex-start;
  //  -o-justify-content: flex-start;
  //  justify-content: flex-start;
  //}
  //
  ///*弹性盒子元素将向行结束位置对齐(从右向左排布)*/
  //.u-justify-end {
  //  display: -webkit-flex;
  //  display: -moz-flex;
  //  display: -ms-flex;
  //  display: -o-flex;
  //  display: flex;
  //  -webkit-justify-content: flex-end;
  //  -moz-justify-content: flex-end;
  //  -ms-justify-content: flex-end;
  //  -o-justify-content: flex-end;
  //  justify-content: flex-end;
  //}

  .l-hotLine {
    padding: 30px 0;
    background: #fff;
  }

  .l-hotLine-item {
    width: 33.3333%;
  }

  .l-hotLine-box {
    width: 300px;
    height: 420px;
  }

  .l-hotLine-desc {
    -webkit-perspective: 1000px;
    perspective: 1000px;
    width: 100%;
    min-height: 370px;
    position: relative;
    -webkit-transition: -webkit-transform 0.7s cubic-bezier(0.4, 0.2, 0.2, 1);
    transition: -webkit-transform 0.7s cubic-bezier(0.4, 0.2, 0.2, 1);
    -o-transition: transform 0.7s cubic-bezier(0.4, 0.2, 0.2, 1);
    transition: transform 0.7s cubic-bezier(0.4, 0.2, 0.2, 1);
    transform-style: preserve-3d;
    -webkit-transform-style: preserve-3d
  }

  .l-hotLine-box:hover .l-hotLine-desc {
    transform: rotateY(180deg);
    -webkit-transform: rotateY(180deg);
  }

  .front, .back {
    width: 100%;
    min-height: 400px;
    height: auto;
    text-align: center;
    border-radius: 6px;
    position: absolute;
    top: 0;
    left: 0;
    -webkit-backface-visibility: hidden;
    backface-visibility: hidden;
  }

  .front .inner {
    margin-top: 60px;
  }

  .front01 {
    background: url(../../../assets/img/coretec/hot01_icon22.png) no-repeat center top;
    background-position-y: -9px;
  }

  .front02 {
    background: url(../../../assets/img/coretec/hot02_icon22.png) no-repeat center top;
    background-position-y: -7px;
  }

  .front03 {
    background: url(../../../assets/img/coretec/hot03_icon22.png) no-repeat center top;
    background-position-y: -9px;
  }

  .front {
    //z-index: 1;
    display: block;
    opacity: 1;
    padding: 10px;
    background-color: #fff;
    height: 100%;
    box-shadow: 0px 0px 18px 0px rgba(0, 0, 0, 0.15);
  }

  .back {
    padding: 30px;
    background: url(../../../assets/img/coretec/hotLine-bg.png);
    box-shadow: 0px 0px 32px 0px rgba(0, 0, 0, 0.3);
    background-repeat: no-repeat;
    line-height: 24px;
    background-size: 110%;
  }

  .l-hotLine-desc .back {
    -webkit-transform: rotateY(180deg);
    transform: rotateY(180deg);
    -webkit-transform-style: preserve-3d;
    transform-style: preserve-3d
  }

  .l-hotLine-desc .front {
    -webkit-transform: rotateY(0deg);
    transform: rotateY(0deg);
    -webkit-transform-style: preserve-3d;
    transform-style: preserve-3d
  }

  .l-hotLine-img {
    width: 164px;
    margin-bottom: 30px;
  }

  .l-hotLine-item-title {
    font-size: 18px;
    line-height: 30px;
    margin-bottom: 126px;
    color: #333;
    height: 60px;
    font-weight: bold;
    text-align: center;
  }

  .l-hotLine-ic {
    width: 36px;
    margin: 0 5px;
  }

  .l-hotLine-item-desc {
    font-size: 18px;
    color: #888888;
    display: flex;
    text-align: left;
  }

  .l-hotLine-item-desc p:first-child {
    text-align: right;
    width: 45%;
  }

  .l-hotLine-item-desc p:last-child {
    flex: 1;
    font-weight: bold;
    color: #333;
    margin-left: 15px;
  }

  .l-hotLine-item-desc span {
    color: #057EFF;
  }


  .l-hotLine-item-title2 {
    font-size: 20px;
    color: #333;
    margin-bottom: 25px;
  }

  .l-hotLine-item-desc2 {
    font-size: 12px;
    text-align: left;
    text-indent: 2em;
    color: #888888;
  }

  .l-hotLine-item-desc2 p {
    text-indent: 2em;
  }
}

.visible-xs {
  width: 100%;
  overflow-x: hidden;

  .core-technology {
    .banner-img {
      width: 100%;
      max-height: 30rem;
    }

    .title {
      font-size: 1.5rem;
      font-family: Arial, Source Han Sans CN;
      font-weight: 300;
      color: rgba(63, 74, 93, 1);
      line-height: 3rem;
      letter-spacing: 0.25rem;
      text-align: center;
    }

    .introduction {
      margin-top: 0.5rem;
      width: 100%;
      font-size: 0.8rem;
      text-indent: 2rem;
      font-family: Arial, Source Han Sans CN;
      font-weight: 200;
      color: rgba(102, 102, 102, 1);
      line-height: 1.31rem;
      letter-spacing: 1px;
    }

    .banner-operate {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      position: absolute;
      z-index: 1001;
      height: 100%;
      left: 7.5%;
      top: 0;
      width: 85%;

      .core-technology-ul {
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 100%;
        max-width: 28rem;
        margin-top: 1.5rem;

        .core-technology-item {
          display: flex;
          flex-direction: column;
          align-items: center;
          width: auto;

          .item-img {
            width: 2.5rem;
            // border:1px dashed rgba(0,0,0,0.3);
            margin-bottom: 0.5rem;
          }

          .item-title {
            font-size: 0.6rem;
            font-family: Arial, Source Han Sans CN;
            font-weight: 400;
            color: rgba(63, 74, 93, 1);
            line-height: 1.25rem;
          }
        }
      }

      .operate {
        display: flex;
        justify-content: left;
        margin-top: 2rem;

        .operate-button {
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          width: 8.0625rem;
          height: 2.3925rem;
        }

        .understand-more {
          background: url("../../../assets/img/mainpage/button01.png") no-repeat;
          background-size: contain;

          .unserstand-more-logo {
            background: url("../../../assets/img/mainpage/arrow_black.png") no-repeat;
            background-size: contain;
            width: 0.726rem;
            height: 0.315rem;
            margin-left: 0.187rem;
          }
        }

        .understand-more:hover {
          background: url("../../../assets/img/mainpage/button01_active.png") no-repeat;
          background-size: contain;
          color: #ffffff;

          .unserstand-more-logo {
            background: url("../../../assets/img/mainpage/Arrow.png") no-repeat;
            background-size: contain;
            width: 0.726rem;
            height: 0.315rem;
            margin-left: 0.187rem;
          }
        }
      }
    }
  }
}

.english {
  .title {
    letter-spacing: 0 !important;
  }

  .introduction {
    letter-spacing: 0 !important;
  }

  .hidden-xs {
    .core-technology-ul {
      // .core-technology-item {
      //   width: auto;
      // }
    }
  }

  .visible-xs {
    .core-technology-item {
      .item-title {
        max-width: 95% !important;
        line-height: 0.8rem !important;
        text-align: center !important;

      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/home/MainCoreTechnology.vue